import BSModal from 'react-bootstrap/Modal'

// This is just a pass through component to bootstrap in case we need to style our modals explicitly
const Modal = BSModal

export default Modal
